define(function (require, exports, module) {
    var tool = require('tool'),
        $ = require('jquery');

    return tool.init($);
});



// WEBPACK FOOTER //
// ./modules/tool/0.0.0/toolLoaderPC.js